/**
 * The user who created a row (transactions, transaction types, behavior types,
 * street cred records). The database fills the creator column; rows made before
 * 2026-10-01 have none.
 */
export interface Creator {
  id: string;
  firstname: string | null;
  lastname: string | null;
  email: string | null;
  teachers?: { id: string }[] | { id: string } | null;
}

export function creatorName(creator?: Creator | null): string | null {
  if (!creator) return null;
  const name = `${creator.firstname || ''} ${creator.lastname || ''}`.trim();
  return name || creator.email || null;
}

/** Teacher profile route, or null when the creator has no teacher record. */
export function creatorProfilePath(creator?: Creator | null): string | null {
  const teacher = Array.isArray(creator?.teachers) ? creator?.teachers[0] : creator?.teachers;
  return teacher?.id ? `/admin/view-teacher/${teacher.id}` : null;
}
